import React, { Component } from 'react';

import PageContainer from '../components/PageContainer/PageContainer';


class MainLayout extends Component {
  render() {
    
    return (
      <div>
        <PageContainer>
          { this.props.children }
        </PageContainer>
      </div>
    );
  }
}

export default MainLayout;



// WEBPACK FOOTER //
// ./src/pages/MainLayout.js